import * as utils from '../utils/utils';
const API_KEY = `${process.env.REACT_APP_API_KEY}`;
export const DB_KEY = `${process.env.REACT_APP_FIREBASE_KEY}`;


//
// FETCHING PERSON INFO
//

export const fetch_person_images = id => {
  const url = `https://api.themoviedb.org/3/person/${id}/images?api_key=${API_KEY}&language=en-US`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapPersonImages(data);
    })
    .catch(error => console.log(error));
};

export const fetch_person_credits = id => {
  const url = `https://api.themoviedb.org/3/person/${id}/combined_credits?api_key=${API_KEY}&language=en-US`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapPersonCredits(data);
    })
    .catch(error => console.log(error));
};

export const fetch_person_details = id => {
  const url = `https://api.themoviedb.org/3/person/${id}?api_key=${API_KEY}&language=en-US`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapPersonDetails(data);
    })
    .catch(error => console.log(error));
};

//
// FETCHING TITLE INFO
//

export const fetch_reviews = (type, id) => {
  const url = `https://api.themoviedb.org/3/${type}/${id}/reviews?api_key=${API_KEY}&language=en-US`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapReviews(data);
    })
    .catch(error => console.log(error));
};

export const fetch_title_trailers = (type, id) => {
  const url = `https://api.themoviedb.org/3/${type}/${id}/videos?api_key=${API_KEY}&language=en-US`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapTrailers(data);
    })
    .catch(error => console.log(error));
};

export const fetch_credits = (type, id) => {
  const url = `https://api.themoviedb.org/3/${type}/${id}/credits?api_key=${API_KEY}&language=en-US`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapCredits(data);
    })
    .catch(error => console.log(error));
};

export const fetch_details = (type, id) => {
  const url = `https://api.themoviedb.org/3/${type}/${id}?api_key=${API_KEY}&language=en-US`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapDetails(data);
    })
    .catch(error => console.log(error));
};

//
// SEARCHING
//

export const multi_search = query => {
  const url = `https://api.themoviedb.org/3/search/multi?api_key=${API_KEY}&language=en-US&query=${query}&page=1&include_adult=false`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapMultiData(data);
    })
    .catch(error => console.log(error));
};

//
// MILTI INFO SEARCH
//

export const inf_search = (type, query, page) => {
  type = type === 'All' ? 'multi' : type.toLowerCase();
  const url = `https://api.themoviedb.org/3/search/${type}?api_key=${API_KEY}&language=en-US&query=${query}&page=${page}&include_adult=false`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapMultiData(data);
    })
    .catch(error => console.log(error));
};

//
// FETCHING GENRES
//

export const fetch_genres_movies_id = () => {
  const url = `https://api.themoviedb.org/3/genre/movie/list?api_key=${API_KEY}&language=en-US`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.reduceGenres(data);
    })
    .catch(error => console.log(error));
};

export const fetch_genres_tv_id = () => {
  const url = `https://api.themoviedb.org/3/genre/tv/list?api_key=${API_KEY}&language=en-US`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.reduceGenres(data);
    })
    .catch(error => console.log(error));
};

//
// FETCHING MOVIES
//

export const fetch_upcoming_movies = () => {
  const url = `https://api.themoviedb.org/3/movie/upcoming?api_key=${API_KEY}&language=en-US&page=1`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapMovies(data);
    })
    .catch(error => console.log(error));
};

export const fetch_top_rated_movies = () => {
  const url = `https://api.themoviedb.org/3/movie/top_rated?api_key=${API_KEY}&language=en-US&page=1`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapMovies(data);
    })
    .catch(error => console.log(error));
};

export const fetch_popular_movies = () => {
  const url = `https://api.themoviedb.org/3/movie/popular?api_key=${API_KEY}&language=en-US&page=1`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapMovies(data);
    })
    .catch(error => console.log(error));
};

export const fetch_now_playing_movies = () => {
  const url = `https://api.themoviedb.org/3/movie/now_playing?api_key=${API_KEY}&language=en-US&page=1`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapMovies(data);
    })
    .catch(error => console.log(error));
};

export const fetch_trending_movies = () => {
  const url = `https://api.themoviedb.org/3/trending/movie/week?api_key=${API_KEY}`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      const modData = data.results.slice(0, 3);
      return utils.mapTrending(modData);
    })
    .catch(error => console.log(error));
};

//
// FETCHING TVs
//

export const fetch_airing_today_tv = () => {
  const url = `https://api.themoviedb.org/3/tv/airing_today?api_key=${API_KEY}&language=en-US&page=1`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapTvs(data);
    })
    .catch(error => console.log(error));
};

export const fetch_on_the_air = () => {
  const url = `https://api.themoviedb.org/3/tv/on_the_air?api_key=${API_KEY}&language=en-US&page=1`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapTvs(data);
    })
    .catch(error => console.log(error));
};

export const fetch_popular_tv = () => {
  const url = `https://api.themoviedb.org/3/tv/popular?api_key=${API_KEY}&language=en-US&page=1`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapTvs(data);
    })
    .catch(error => console.log(error));
};

export const fetch_top_rated_tv = () => {
  const url = `https://api.themoviedb.org/3/tv/top_rated?api_key=${API_KEY}&language=en-US&page=1`;
  return fetch(url)
    .then(resp => resp.json())
    .then(data => {
      return utils.mapTvs(data);
    })
    .catch(error => console.log(error));
};
